import { dormantClients, type DormantClient } from "@/mocks/managerWorkspace";

export default function DormantClientsWidget() {
  const visibleClients = dormantClients.slice(0, 3);

  return (
    <div className="bg-white rounded-lg border border-[#D5CA8A] overflow-hidden h-full flex flex-col">
      <div className="flex items-center justify-between px-3 py-1.5 bg-[#FEF3C7] border-b border-[#D5CA8A]">
        <div className="flex items-center gap-1.5">
          <i className="ri-user-unfollow-line text-[12px] text-[#B45309]"></i>
          <span className="text-[11px] font-semibold text-[#2D2D2D]">Давно не покупали</span>
        </div>
        <span className="text-[11px] font-bold text-[#B45309]">{dormantClients.length}</span>
      </div>
      <div className="flex-1 overflow-auto">
        <table className="w-full text-[10px]">
          <thead>
            <tr className="bg-[#FDF2B5]/50 text-[#666666]">
              <th className="text-left px-2 py-1 font-medium">Клиент</th>
              <th className="text-left px-2 py-1 font-medium">Посл. покупка</th>
              <th className="text-left px-2 py-1 font-medium">Дней</th>
              <th className="text-left px-2 py-1 font-medium">Группа</th>
            </tr>
          </thead>
          <tbody>
            {visibleClients.map((c: DormantClient, i: number) => (
              <tr key={i} className="border-b border-[#D5CA8A]/30 hover:bg-[#FDF2B5]/30 transition-colors">
                <td className="px-2 py-1 text-[#2D2D2D] text-[9px]">{c.name}</td>
                <td className="px-2 py-1 text-[#666666] text-[9px]">{c.lastPurchase}</td>
                <td className="px-2 py-1">
                  <span className={`px-1 py-0.5 rounded text-[8px] font-medium ${c.daysSincePurchase > 200 ? "bg-[#FEE2E2] text-[#DC2626]" : c.daysSincePurchase > 120 ? "bg-[#FEF3C7] text-[#D97706]" : "bg-[#D4EDDA] text-[#2D6A4F]"}`}>
                    {c.daysSincePurchase}
                  </span>
                </td>
                <td className="px-2 py-1 text-[#666666] text-[9px]">{c.productGroup}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-3 py-1 border-t border-[#D5CA8A]">
        <button className="text-[10px] text-[#2D2D2D] hover:bg-[#FDF2B5] px-2 py-0.5 rounded transition-colors cursor-pointer">
          Все клиенты
        </button>
      </div>
    </div>
  );
}